import axios from 'axios';
import FileSaver from 'file-saver';
import store from '../store/store.ts';
import showMessage from '../utils/showSocketMessage.js';
import i18n from '../locales/i18n.ts';
import { handleLogout, isAuthError } from '../utils/auth.js';
const fileFetch = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/file`,
});
const printFetch = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/print`,
});
fileFetch.interceptors.request.use(
  (config) => {
    const token = store.getState().user.token;
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
fileFetch.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle authentication errors (401 Unauthorized or 403 Forbidden)
    if (isAuthError(error)) {
      handleLogout();
    } else if (error.response) {
      const message =
        error.response.data?.message || i18n.t('errors.serverError');
      showMessage(message, 'error');
    } else if (error.request) {
      showMessage(i18n.t('errors.networkError'), 'error');
    }
    return Promise.reject(error);
  }
);

printFetch.interceptors.request.use(
  (config) => {
    const token = store.getState().user.token;
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

printFetch.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle authentication errors (401 Unauthorized or 403 Forbidden)
    if (isAuthError(error)) {
      handleLogout();
    } else if (error.response) {
      const message =
        error.response.data?.message || i18n.t('errors.serverError');
      showMessage(message, 'error');
    } else if (error.request) {
      showMessage(i18n.t('errors.networkError'), 'error');
    }
    return Promise.reject(error);
  }
);
export const getExpenses = () => {
  return fileFetch.get('/');
};
export const printPDF = async (
  selectedOptions,
  priceSummary,
  messageHistory
) => {
  try {
    const response = await printFetch.post(
      '/export-pdf',
      { selectedOptions, priceSummary, messageHistory },
      { responseType: 'blob' }
    );
    const contentDisposition = response.headers['content-disposition'];
    const filename = contentDisposition
      ? contentDisposition.split('=')[1].replace(/"/g, '')
      : 'document.pdf';
    FileSaver.saveAs(response.data, filename);
  } catch (error) {
    console.error('Ошибка при генерации PDF:', error);
    throw error;
  }
};
